import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'
import { iconOptionsList } from 'consts'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
  setValue: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    // fetch the device if edit
    if (props.id !== undefined) {
      loadRecord(apiUrls.sections, props.id).then((data) => {
        props.reset(data)

        const currIconObj: any = iconOptionsList.find((o) => o.id === data.icon)
        props.setValue('icon', currIconObj)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } 
    else {
      const defaultIcon = iconOptionsList[0] ?? null
      props.setValue('icon', defaultIcon)
      props.setDataLoaded(true)
      props.setShowOverlay(false)
    }
  }, [props.currentCustomer])
}

export default useInit
